(function($) {
  $(document).ready(function() {
    $('.featured-posts--slider').each(function() {
      var $slider = $(this);
      if (typeof $.fn.slick === 'function') {
        $slider.slick({
          arrows: true,
          dots: false,
          infinite: true,
          draggable: true,
          autoplay: false,
          fade: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 1000,
          adaptiveHeight: true,
          prevArrow: '<div class="ts-prev" aria-label="Previous" type="button"><i class="ion-chevron-left"></i></div>',
          nextArrow: '<div class="ts-next" aria-label="Next" type="button"><i class="ion-chevron-right"></i></div>'
        });
      }
    });
  });
})(jQuery);